import BannerRodape from "@/components/BannerRodape";
import DialogLoginCliente from "@/pages/cliente/areaAberta/login/DialogLoginCliente";
import Inicio from "@/pages/common/simulacao/Inicio";
import {
  ehAreaLogadaCliente,
  ehAreaParceiro,
  retornaRotaPagamento,
} from "@/services/ambiente";
import { getClientIdGoogle } from "@/services/analyticsEvent";
import { post } from "@/services/api";
import { post as postParceiro } from "@/services/apiParceiro";
import { registerMetadata } from "@/services/metadataEvent";
import {
  activeSpinner,
  cancelSpinner,
  setInfoDialog,
} from "@/store/reducers/geral";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import EtapaConfirmacaoParceiro from "./EtapaConfirmacaoParceiro";
import EtapaDadosPessoais from "./EtapaDadosPessoais";
import EtapaDadosPessoaisParceiro from "./EtapaDadosPessoaisParceiro";
import EtapaItemsPagamento from "./EtapaItemsPagamento";
import EtapaSimulacao from "./EtapaSimulacao";

export default function Simulacao({
  dadosUsuario,
  setDadosUsuario,
  setNavegarEtapa,
  carregarEtapa,
  setCarregarEtapa,
  company,
  limparDados,
  abrirLinkPagamento,
}) {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const { etapa } = useParams();
  const [activeStep, setActiveStep] = useState(1);
  const [infoDialogLogin, setInfoDialogLogin] = useState({ open: false });
  const [adminSimulacao, setAdminSimulacao] = useState(false);

  useEffect(() => {
    if (etapa) {
      setActiveStep(parseInt(etapa));
      setCarregarEtapa(true);
    }
  }, [etapa, setCarregarEtapa]);

  const avancarParaPagamentoAreaLogada = () => {
    const rota = retornaRotaPagamento({
      idRequest: dadosUsuario.idRequest,
      token: dadosUsuario.token,
      try3ds: dadosUsuario.try3ds,
      try3dsEP: dadosUsuario.try3dsEP,
    });
    navigation(rota);
  };

  const avancarParaAutenticacao = () => {
    if (!dadosUsuario.isB2c) {
      setNavegarEtapa(4);
      return;
    }
    if (ehAreaLogadaCliente()) {
      avancarParaPagamentoAreaLogada();
      return;
    }
    sessionStorage.setItem("idRequestPayment", dadosUsuario.idRequest);
    sessionStorage.setItem("idRequestToken", dadosUsuario.token);
    const cpfCnpj = dadosUsuario.cpf || dadosUsuario.cnpj;
    setInfoDialogLogin({
      open: true,
      cpfCnpj: cpfCnpj,
      idRequestBind: dadosUsuario.idRequest,
      tokenRequestBind: dadosUsuario.token,
    });
  };

  const salvarSimulacaoParaLink = async (values) => {
    const dados = { ...values };
    if (ehAreaParceiro()) {
      dados.companyStep = etapa;
    }
    return await salvarSimulacao(dados);
  };

  const salvarSimulacao = (values) => {
    var promise = new Promise(async (resolve, reject) => {
      try {
        const idClient = await getClientIdGoogle();
        const step = etapa || 1;
        values = { ...values };
        const idVersionSimulator = localStorage.getItem("idVersionSimulator");
        const idMetadataMarketing = sessionStorage.getItem(
          "idMetadataMarketing"
        );
        values.idMetadataMarketing = idMetadataMarketing || "";
        values.clientIdGoogle = idClient;
        values.idVersionSimulator = idVersionSimulator;

        const metaData = {};
        metaData.isMobile = isMobile;
        metaData.userAction = `SIMULATOR_${step}`;
        metaData.url = window.location.href;
        metaData.clientIdGoogle = idClient || "";
        registerMetadata(metaData);

        dispatch(activeSpinner());
        let result;
        if (ehAreaParceiro()) {
          result = await postParceiro(`secure/requests/${step}`, values);
        } else {
          if (ehAreaLogadaCliente()) {
            result = await post(`secure/requests/${step}`, values);
          } else {
            result = await post(`public/simulation/${step}`, values);
          }
        }
        dispatch(cancelSpinner());
        if (result.error) {
          dispatch(setInfoDialog({ open: true, descricao: result.error }));
          reject({ error: result.error, erroTratado: true });
          return;
        }
        resolve(result);
      } catch (e) {
        console.log(e);
        dispatch(
          setInfoDialog({
            open: true,
            descricao:
              "Ocorreu um erro ao simular. Tente novamente em instantes!",
          })
        );
        dispatch(cancelSpinner());
        reject(e);
      }
    });
    return promise;
  };

  function getStepContent(step) {
    if (!step) {
      return (
        <Inicio
          {...{
            salvarSimulacao,
            setNavegarEtapa,
            dadosUsuario,
            setDadosUsuario,
            carregarEtapa,
            setCarregarEtapa,
          }}
        />
      );
    }

    const permiteVoltarEtapa = () => {
      if (!dadosUsuario.companyStep) {
        return true;
      }
      return parseInt(etapa) > parseInt(dadosUsuario.companyStep);
    };

    switch (step) {
      case 1: {
        if (ehAreaParceiro()) {
          return (
            <EtapaDadosPessoaisParceiro
              {...{
                salvarSimulacao,
                salvarSimulacaoParaLink,
                setNavegarEtapa,
                dadosUsuario,
                setDadosUsuario,
                carregarEtapa,
                setCarregarEtapa,
                company,
                abrirLinkPagamento,
                limparDados,
                permiteVoltarEtapa,
                avancarParaAutenticacao,
              }}
            />
          );
        }

        return (
          <EtapaDadosPessoais
            {...{
              adminSimulacao,
              setAdminSimulacao,
              salvarSimulacao,
              setNavegarEtapa,
              dadosUsuario,
              setDadosUsuario,
              carregarEtapa,
              setCarregarEtapa,
            }}
          />
        );
      }
      case 2:
        return (
          <EtapaSimulacao
            {...{
              adminSimulacao,
              salvarSimulacao,
              setNavegarEtapa,
              dadosUsuario,
              setDadosUsuario,
              carregarEtapa,
              setCarregarEtapa,
              permiteVoltarEtapa,
              avancarParaAutenticacao,
              avancarParaPagamentoAreaLogada,
            }}
          />
        );
      case 3:
        return (
          <EtapaItemsPagamento
            {...{
              salvarSimulacao,
              salvarSimulacaoParaLink,
              setNavegarEtapa,
              dadosUsuario,
              setDadosUsuario,
              carregarEtapa,
              abrirLinkPagamento,
              setCarregarEtapa,
              permiteVoltarEtapa,
              avancarParaAutenticacao,
            }}
          />
        );
      case 4:
        return (
          <EtapaConfirmacaoParceiro
            {...{
              salvarSimulacao,
              salvarSimulacaoParaLink,
              setNavegarEtapa,
              dadosUsuario,
              setDadosUsuario,
              abrirLinkPagamento,
              carregarEtapa,
              setCarregarEtapa,
              permiteVoltarEtapa,
            }}
          />
        );
      default:
        return (
          <Inicio
            {...{
              salvarSimulacao,
              setNavegarEtapa,
              dadosUsuario,
              setDadosUsuario,
              carregarEtapa,
              setCarregarEtapa,
            }}
          />
        );
    }
  }

  return (
    <Container
      className="container-tests"
      component="main"
      maxWidth={
        ehAreaLogadaCliente() && (activeStep === 1 || activeStep === 2)
          ? "sm"
          : "md"
      }
      sx={{ mb: 15 }}>
      <Paper
        variant="outlined"
        sx={{ my: { xs: 1, md: 2 }, p: { xs: 2, md: 3 } }}>
        <>
          <>{getStepContent(activeStep)}</>
        </>
      </Paper>
      {infoDialogLogin.open && (
        <DialogLoginCliente {...{ infoDialogLogin, setInfoDialogLogin }} />
      )}

      <BannerRodape />
    </Container>
  );
}
